(ns motorsaif.shared.chat
  (:require
   [taoensso.encore :as encore]
   [motorsaif.string :refer [format]]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   [reagent.core :as r]
   [motorsaif.validation :as validation]
   [motorsaif.data-utils :as du]
   [motorsaif.time :as time]))

(defn other-participant
  [{:keys [thread request current-owner-id]}]
  (let [{:keys [participants]} thread]
    (or
     (ffirst (filter #(not= (:db/id (first %)) current-owner-id) participants))
     ;; We don't have a thread yet, so participant is request owner
     (:owner request))))

(defn author-from-user-id
  [participants {:keys [from-id audit-user-id]}]
  (let [[from audit]
        (first (filter (fn [[from-user audit-user]]
                   (and (= (:db/id from-user) from-id)
                        (= (:db/id audit-user) audit-user-id)))
                 participants))]
    (cond-> {:from from}
      (not= from audit)
      (assoc :audit audit))))

;; (map (comp :date-time/created :message) (concat zher))

(defn thread*
  "Refine backend thread"
  [{:keys [thread *client-msgs current-owner-id current-user-id] :as argz}]
  (let [{:keys [messages touches participants]} thread
        other-participant-id (:db/id (other-participant {:thread thread
                                                         :current-owner-id current-owner-id}))
        author-data (partial author-from-user-id participants)]
    (loop [msgs (sort-by (comp :date-time/created :message) (concat messages @*client-msgs))
           last-from-id nil
           last-date nil
           acked-uuids #{}
           acc []]
      (let [remaining-msgs (rest msgs)
            next-msg (:message (first remaining-msgs))

            {curr-msg :message
             audit-user-id :audit-user-id} (first msgs)

            created (:date-time/created curr-msg)

            [from-id
             next-from-id] (map #(get-in % [:message/from :db/id]) [curr-msg next-msg])

            is-owner? (= from-id current-owner-id)
            is-user? (= audit-user-id current-user-id)
            date (when curr-msg (time/udt->format
                                 created
                                 "MMMM d yyyy"))
            new-date? (not= date last-date)
            new-author? (not= last-from-id from-id)
            has-next? (= from-id next-from-id)

            ?uuid (:uuid curr-msg)
            ack? (some? (:db/id curr-msg))

            author (author-data {:from-id from-id
                                 :audit-user-id audit-user-id})

            last-access (get-in touches [other-participant-id :touched/last-access])
            seen? (and last-access
                       created
                       (time/after? last-access created))]

        (if (empty? msgs)
          acc
          (recur remaining-msgs
                 from-id
                 date
                 (cond-> acked-uuids
                   (and ?uuid ack?) (conj ?uuid))
                 (-> acc
                     (cond-> new-date?
                       (conj {:date date
                              :type :date})
                       (not (acked-uuids ?uuid))
                       (conj (assoc curr-msg
                                    :ack? ack?
                                    :is-owner? is-owner?
                                    :is-user? is-user?
                                    :seen? seen?
                                    :type :msg
                                    :author author
                                    :new-author? new-author?
                                    :has-next? has-next?))))))))))

(defn chat-frame-wrap
  "Wraps chat frame passing in data from route and subscriptions"
  []
  (let [current-owner-id @(subscribe [:current-owner-id])
        {:keys [request-id owner-id]} @(subscribe [:route/parameters])

        request @(subscribe [:request request-id])

        client-msgs (subscribe [:client-msgs])
        {:keys [request thread-id from-id] :as argz}
        (condp = (get-in @(subscribe [:route/data]) [:data :name])
          :responder-thread (let [?msg @(subscribe [:responder-thread request-id])
                                  thread-id [request-id current-owner-id]]
                              (if ?msg ; thread exists
                                (assoc ?msg
                                       :thread-id thread-id
                                       :from-id current-owner-id)
                                ;; new response, thread does not exist
                                {:from-id current-owner-id
                                 :thread-id thread-id
                                 :request request}))
          :requester-thread
          (assoc @(subscribe [:requester-thread request-id owner-id])
                 :request-id request-id
                 :thread-id [request-id owner-id]
                 :request @(subscribe [:current-owner-request request-id])
                 :from-id owner-id))
        *thread (subscribe [:thread thread-id])]

    {:current-owner-id current-owner-id
     :from-id from-id
     :thread-id thread-id
     :client-msgs client-msgs
     :request request
     :*thread *thread}))


(defn chat-form-params [{:keys [id
                                body
                                thread-id
                                current-owner-id
                                current-user-id
                                clear-input-fn
                                from-id] :as args}]

  (assert (and (every? number? thread-id)
               (= 2 (count thread-id)))
          (format "Thread ID must be 2 numbers, got %d elements: %s"
                  (count thread-id)
                  thread-id))
  (encore/have some? current-owner-id  from-id)

  (let [init-fn (fn [] (-> {:uuid (random-uuid)
                            :message (-> {:message/thread thread-id
                                          :message/from current-owner-id}
                                         (du/assoc-if-val :message/body body))}
                           (du/assoc-if-val :db/id id)))

        on-submit (fn [{:keys [all-data]}]
                    (clear-input-fn)
                    (let [{:keys [uuid message]} all-data
                          client-msg (-> message
                                         (assoc :uuid uuid
                                                :message/from {:db/id current-owner-id}
                                                :date-time/created (time/date)))
                          edit? (some? (:db/id message))
                          request-type (if edit? :PUT :POST)
                          req
                          {:type request-type
                           :url "/api/messages"
                           :params {:data all-data}
                           :id (str :new-message uuid)
                           :handler (fn [{:keys [success data ex-message] :as res}]
                                      (let [{:keys [msg]} data
                                            msg (assoc msg :uuid uuid)]
                                        (if success
                                          (do
                                            ;; NOTE Temporary hack
                                            (rf/dispatch [:touch-topic thread-id])
                                            ;; NOTE Is sync needed?
                                            (if edit?
                                              (rf/dispatch [:fetch-messages]) ;; NOTE: Temp low effort code, make better later
                                              (rf/dispatch-sync [:update-data [:threads thread-id :messages] conj
                                                                {:message msg
                                                                 :audit-user-id current-user-id}]))
                                            (rf/dispatch-sync [:update-data :client-msgs
                                                               (fn [msgs]
                                                                 (vec (filter #(not= (get-in % [:message :uuid]) uuid) msgs)))])
                                            #_(rf/dispatch [:fetch-messages
                                                            #(debounced-scroll-bottom @*ul-ref)]))
                                          (rf/dispatch
                                           [:toast {:type "error"
                                                    :message (format "Error %s: " ex-message)}]))))
                           :error-handler (fn [res]
                                            (println [:error res]))}]

                      (when-not :edit?
                        (rf/dispatch-sync [:update-data :client-msgs (fnil conj [])
                                           {:audit-user-id current-user-id
                                            :message client-msg}]))
                      (rf/dispatch [:do-ajax req])))]
    {:schema validation/message
     :on-submit {:valid on-submit
                 :reset true ;; Trigger init-fn again for new UUID
                 :invalid (fn [error]
                            (println "Submit error " error))}
     :init-fn init-fn}))
